import React from 'react';
import { Shield } from 'lucide-react';
import type { Player } from '../../types';
import { InjuryBadge } from './InjuryBadge';
import type { InjuryStatus } from '../../constants/injuries';

interface PlayerNameWithIconProps {
  player: Player;
  showNumber?: boolean;
  className?: string;
  iconClassName?: string;
  numberFirst?: boolean;
}

export const PlayerNameWithIcon: React.FC<PlayerNameWithIconProps> = ({
  player,
  showNumber = false,
  className = '',
  iconClassName = 'h-4 w-4 text-primary',
  numberFirst = false
}) => {
  const displayName = numberFirst && showNumber 
    ? `#${player.number} ${player.first_name} ${player.last_name}`
    : showNumber 
    ? `${player.first_name} ${player.last_name} ${player.number ? `#${player.number}` : ''}`
    : `${player.first_name} ${player.last_name}`;

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <span>{displayName}</span>
      {player.playParticipation?.hasMPR && (
        <Shield className={iconClassName} />
      )}
      <InjuryBadge injuryStatus={player.injury_status as InjuryStatus} />
    </div>
  );
}; 